import React, { useMemo } from "react";
import s from "~/components/Table/TableRow/SRRTableRow/TableRow.less";
import clsx from "clsx";
import { getNumberYearMonthDay } from "~/libs/getDateOptions";

const TOReturnCarForServiceByPeriodConsolidated = ({
  row,
  options,
  optionsChildren,
  group,
}: any) => {
  const groups = group.arrTO;
  const keysInGroup = ["nameDealer", "inn", "dateVisit", "countDay"];
  const optionsWithoutTO = optionsChildren.reduce((acc, el) => {
    return keysInGroup.includes(el) ? acc : [...acc, el];
  }, []);

  const doObjFlat = (obj: { [key: string]: any }) => {
    return Object.keys(obj).reduce((acc, key) => {
      if (
        !obj[key] ||
        (typeof obj[key] !== "object" && !Array.isArray(obj[key]))
      ) {
        return { ...acc, [key.toUpperCase()]: obj[key] };
      } else {
        // Костыль
        if (key === "dealer")
          return {
            ...acc,
            ...doObjFlat({
              ...obj[key],
              dealerName: obj[key].name,
              nameDealer: obj[key].name,
            }),
          };
        // Костыль 2
        if (key === "client")
          return {
            ...acc,
            ...doObjFlat({
              ...obj[key],
              ClientName: obj[key].name,
            }),
          };
        if (key.search(/TO[0-9]/) !== -1) return acc;
        return { ...acc, ...doObjFlat(obj[key]) };
      }
    }, {});
  };

  const rowFlat = useMemo(() => doObjFlat(row), [row]);
  return (
    <tr className={clsx(s.row_tr, s.row_td)}>
      {optionsWithoutTO.map((optionName: string, id) => {
        return (
          <TableDecimal
            key={optionName + String(id)}
            optionName={optionName}
            value={
              ["dateSales"].includes(optionName)
                ? getNumberYearMonthDay({
                    date: rowFlat[optionName.toUpperCase()],
                  })
                : rowFlat[optionName.toUpperCase()]
            }
          />
        );
      })}
      {groups.map((group, id) => {
        return keysInGroup.map((optionName) => {
          let groupVal;
          if (!!row[group]) {
            groupVal = row[group][optionName];
            if (optionName === "dateVisit" && !!row[group][optionName]) {
              groupVal = getNumberYearMonthDay({
                date: row[group][optionName],
              });
            }
          }
          return (
            <TableDecimal
              key={optionName + String(id)}
              optionName={optionName}
              value={rowFlat[optionName.toUpperCase()] || groupVal}
            />
          );
        });
      })}
    </tr>
  );
};

export default TOReturnCarForServiceByPeriodConsolidated;

const TableDecimal = ({ optionName, value }) => {
  return (
    <td
      style={{ maxWidth: 100, overflow: "hidden" }}
      className={s.tdTO}
      data-option_name={optionName}
    >
      <span className={s.cont}>{value}</span>
    </td>
  );
};
